(function(wnd){
    function FormHandler(container, params) {
        try {
            if (!container) {
                throw 'Container is required!';
            }

            this.container = container;

            if (params) {
                this.setParams(params);
            }

            this.init();
        } catch (error) {
            console.error(error);
        }
    }

    FormHandler.prototype = {
        container: undefined,
        form: undefined,
        sendedForm: false,
        type: '',
        handledRecaptcha: false,
        recaptcha: false,
        recaptchaKey: undefined,
        init: function() {
            this.setElements();
            this.addDOMEvents();
        },
        setElements: function() {
            this.form = this.container.is('form')
                ? this.container 
                : this.container.find('form');
            this.button = this.container.find('[data-purpose="send-button"]');
        },
        addDOMEvents: function() {
            var _self = this;

            this.button.click(function(e){
                e.preventDefault();
                _self.sendForm();
            });

            this.form.submit(function(e){
                e.preventDefault();
            });
        },
        setParams: function(params) {
            if (params.type) this.setType(params.type);
            if (typeof params.collectFormData === 'function') this.collectFormData = params.collectFormData;
            if (typeof params.handleResponseErrors === 'function') this.handleResponseErrors = params.handleResponseErrors;
            if (typeof params.confirmSubscribe === 'function') this.confirmSubscribe = params.confirmSubscribe;
            if (typeof params.recaptchaKey !== 'undefined') this.setRecaptchaKey(params.recaptchaKey);
        },
        handleRecaptcha: function () {
            if (!this.hasRecaptcha()) {
                this.handledRecaptcha = true;
                this.sendedForm = false;
                this.sendForm();

                return;
            }

            var _self = this;
            this.form.find('[name="g-recaptcha-response"]').remove();
            this.form.find('[name="g-recaptcha-action"]').remove();

            grecaptcha.ready(function () {
                grecaptcha.execute(_self.recaptchaKey, {action: _self.type}).then(function (token) {
                    _self.form.prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
                    _self.form.prepend('<input type="hidden" name="g-recaptcha-action" value="'+_self.type+'">');
                    _self.sendedForm = false;
                    _self.handledRecaptcha = true;    
                    _self.sendForm();        
                });
            });
        },
        setType: function(type) {
            this.type = type;
        },
        sendForm: function() {
            if (!this.sendedForm) {
                var _self = this;

                if (!this.handledRecaptcha) {
                    this.handleRecaptcha();
                    return;
                }

                this.sendedForm = true;

                $.ajax({
                    url: this.form.attr('action'),
                    dataType: 'json',
                    type:'post',
                    data: _self.collectFormData(),
                    beforeSend: function() {
                        _self.form.find('.error-content').remove();
                        _self.form.find('.has-error').removeClass('has-error');
                    },
                    success: function(response) {
                        if (response.success) {
                            $(document).trigger('civishaz.sended_form', {
                                data: _self.form.serializeArray(),
                                type: _self.type,
                                form: _self.form,
                            });
                            _self.confirmSubscribe();
                        } else {
                            _self.handleResponseErrors(response.errors);
                        }
                    },
                    complete: function() {
                        if (_self.hasRecaptcha()) {
                            _self.handledRecaptcha = false;
                        }

                        setTimeout(function(){
                            _self.sendedForm = false;
                        }, 500);
                    }
                });
            }
        },
        collectFormData: function() {
            return this.form.serialize();
        },
        handleResponseErrors: function(errors) {
            var _self = this;
            $.each(errors, function(key, msg) {
                var field = _self.form.find('[name="'+key+'"]');
                var label = $('label[for="' + field.attr('id') +'"]');
                field.addClass('has-error');
                label.addClass('has-error');

                if (msg.trim() != '') {
                    var errorContent = $('<div>', {
                        class: 'error-content',
                        html: msg,
                    });

                    errorContent.insertAfter(field.is(':checkbox') ? label : field);
                }
            });
        },
        confirmSubscribe: function() {
            this.form.find('.field').val('');
            this.form.find('[type="checkbox"]').prop('checked', false);
            this.container.addClass('success-sent');
        },
         setRecaptcha: function (recaptcha) {
            this.recaptcha = recaptcha;
        },
        hasRecaptcha: function () {
            return this.recaptcha;
        },
        setRecaptchaKey: function (recaptchaKey) {
            this.recaptchaKey = recaptchaKey;

            if (recaptchaKey.trim() !== '') {
                this.setRecaptcha(true);
            }
        },
        getRecaptchaKey: function () {
            return this.recaptchaKey;
        }
    };

    wnd.FormHandler = FormHandler;
})(window);
